module.exports = __webpack_public_path__ + "static/media/cr.13c483a3.svg";